// extracted by mini-css-extract-plugin
export default {"previewSection":"ReactCropper_previewSection__wWaoR","cropperSection":"ReactCropper_cropperSection__cunn4"};